import { Component, OnInit } from '@angular/core';
import { PATH_NAMES } from '../../shared/constants';
import { CryptoService } from '../../services/crypto/crypto.service';
import { SeoService } from '../../services/seo/seo.service';
import { toUp } from '../../shared/utils';

@Component({
  selector: 'app-condiciones-de-reserva',
  templateUrl: './condiciones-de-reserva.component.html',
  styleUrls: ['./condiciones-de-reserva.component.scss']
})
export class CondicionesDeReservaComponent implements OnInit {

  constructor(private _cryptoService: CryptoService, private _seoService: SeoService, 
  ) { }

  ngOnInit(): void {
    const path  = PATH_NAMES.BOOKING;
		this._seoService.updateSeoByPath(path);
    
    let userID: string = '';
    let user_existingCustomer: boolean = false;
    const credentials = localStorage.getItem('usuario');
    const bookings = localStorage.getItem('bookings');

    if (credentials) {
      const credentialsJson = JSON.parse(credentials);
      userID = this._cryptoService.encrypt(credentialsJson.email);

      if (bookings)
        user_existingCustomer = JSON.parse(bookings).length > 0;
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "user_info",
      userID: userID,
      user_existingCustomer: user_existingCustomer
    });

    (window as any).dataLayer.push({
      event: "virtualPageView",
      virtualPagePath: "/condiciones-de-reserva",
      virtualPageTitle: "NMV: Agenda tu cita"
    });

    toUp()
  }
}
